export class RemoveItemFromBasketAction {
  static type = '[BASKET] Remove item';

  constructor(readonly idx: string, readonly count: number) {}
}
